
<template>
    <div class="main">
        <a-spin class="load" v-show="loading" />
        <div class="book-textreadguide">
            <a-spin class="loading" v-show="loading" />
            <div class="book-textreadguide-content">
            <!-- <div class="back-Btn" @click="goArticle">
                <han-icon type="leftDobuleArrowIcon" class="back-Icon" />
                <span>返回课文</span>
            </div> -->
            <div class="textreadguide-title">课文导读</div>
            <div class="textreadguide-content">{{readGuides.commentContent}}
            </div>
            <div v-if="!readGuides.commentContent">
                <a-empty />
            </div>
            </div>
        </div>
    </div>
</template>

<script>
import HanIcon from 'components/Icon.vue'
export default {
  name: 'TextReadGuide',
  components: { HanIcon },
  data () {
    return {
      loading: false,
      readGuides: ''
    }
  },
  watch: {
    $route () {
      this.getTextReadGuide()
    }
  },
  methods: {
    goArticle () {
      this.$router.push({ path: `/books/reading-book/${this.$route.params.id}` })
    },
    getTextReadGuide () {
      this.$fetch({
        url: this.$baseUrl + 'ebook/textRes/getAppreciation',
        body: {
          styleId: localStorage.getItem('styleId'),
          rangeType: 4
        }
      }).loading(
        () => (this.loading = true),
        () => (this.loading = false)
      ).done(res => {
        // console.log(res)
        this.readGuides = res.resultData
      })
    }
  },
  mounted () {
    this.getTextReadGuide()
  }
}
</script>
<style lang="less" scoped>
.main{
    position: relative;
    .load{
        position: absolute;
        top: 45%;
        left: 50%;
        transform: translate(50%,50%);
        z-index: 99;
    }
    .book-textreadguide {
      background-color: #f1f0f0;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .book-textreadguide-content {
    border-radius: @border-radius-base;
    background-color: @white;
    font-weight: normal;
    width: 1240px;
    margin-top: 30px;
    padding-top: 53px;
    padding-left: 50px;
    padding-bottom: 55px;
    padding-right: 50px;
    justify-content: center;
    flex-direction: column;
    .back-Btn {
        display: inline-block;
        justify-content: left;
        align-items: center;
        cursor: pointer;
        font-size: 20px;
        color: #dbd1cd;
        font-family: "PingFangSC-Semibold";
        height: 30px;
        .back-Icon {
        height: 19px;
        position: relative;
        right: 10px;
        }
    }
    .back-Btn:hover {
        color: @primary-color;
    }
    .textreadguide-title {
        font-family: "STSongti-SC-Black";
        font-size: 24px;
        text-align: center;
        padding-top: 35px;
        padding-bottom: 45px;
        font-weight: bold;
    }
    .textreadguide-content {
        // font-family: "STSongti-SC-Black";
        font-size: 20px;
        white-space: pre-wrap;
        line-height:2em;
    }
    }
}
</style>
